import { render } from "./CompanyBusinessCardPageList.vue?vue&type=template&id=c356f692&scoped=true&ts=true"
import script from "./CompanyBusinessCardPageList.vue?vue&type=script&lang=ts"
export * from "./CompanyBusinessCardPageList.vue?vue&type=script&lang=ts"

import "./CompanyBusinessCardPageList.vue?vue&type=style&index=0&id=c356f692&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c356f692"]])

export default __exports__